import React, { useState, useEffect } from 'react';
import { TextField, Autocomplete, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import { useZIPMountPositionSearchQuery, ZIPExecutionAPI } from '../../../Redux/API/ZIPExecutionAPI';
import { setZIPMountPosition, clearZIPMountParams } from '../../../Redux/Slices/ZIPExecutionSlice';

function ZIPNewPositionInput() {
  const [positionDesc, setPositionDesc] = useState('');
  const [skip, setSkip] = useState(true);

  const dispatch = useDispatch();
  const { ZIPMountPosition } = useSelector((state) => state.ZIPExecution);
  const { data: positionData, isFetching } = useZIPMountPositionSearchQuery(positionDesc, { skip });

  useEffect(() => {
    let delay;
    setSkip(true);
    dispatch(ZIPExecutionAPI.util.invalidateTags(['Positions']));

    if (positionDesc.trim() !== '' && positionDesc.length > 2) {
      delay = setTimeout(() => {
        setSkip(false);
      }, 700);
    } else {
      setSkip(true);
      dispatch(ZIPExecutionAPI.util.invalidateTags(['Positions']));
    }
    return () => clearTimeout(delay);

    // eslint-disable-next-line
  }, [positionDesc]);

  return (
    <>
      <Autocomplete
        id='position'
        freeSolo
        filterOptions={(x) => x}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.position_num + ' ' + option.position_name)}
        options={positionData ? positionData : []}
        sx={{ minWidth: '250px', width: '300px' }}
        size='small'
        onChange={(event, newValue, reason) => {
          reason = 'clear' && dispatch(clearZIPMountParams());
          dispatch(setZIPMountPosition(newValue));
        }}
        value={ZIPMountPosition ?? ''}
        inputValue={positionDesc}
        onInputChange={(event, newInputPosValue) => {
          setPositionDesc(newInputPosValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Позиция&nbsp;&nbsp;&nbsp;&nbsp;'
            InputLabelProps={{ shrink: true }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isFetching ? <CircularProgress color='inherit' size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              style: { fontSize: '12px' },
            }}
          />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={props.id}>
              <span style={{ fontSize: '10px' }}>{option.position_num + ' ' + option.position_name}</span>
            </li>
          );
        }}
      />
    </>
  );
}

export default ZIPNewPositionInput;
